// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"ring-global-ellipsis","wrapper":"AgentInfo__wrapper--_P","agent":"AgentInfo__agent--Xw ring-global-ellipsis","agentPool":"AgentInfo__agentPool--YM ring-global-ellipsis"};